"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseTemplate = void 0;
var BaseTemplate = /** @class */ (function () {
    function BaseTemplate() {
    }
    return BaseTemplate;
}());
exports.BaseTemplate = BaseTemplate;
//# sourceMappingURL=BaseTemplate.js.map